module.exports = __webpack_public_path__ + "static/sport/h5btn.b960d2d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ldp/h5btn.gif
// module id = o0+6
// module chunks = 0